import { pxToRem } from '~/utils';

export default {
  smallRadius: pxToRem(5),
  mediumRadius: pxToRem(10),
  largeRadius: pxToRem(35),
  modalRadius: pxToRem(10),
  buttonRadius: pxToRem(10),
} as RadiusType;
